import Vue from 'vue'
import axios from "axios"
import store from "../store";

const instance = axios.create();

Vue.prototype.$http = instance;

// 1. request 핸들링
// instance.interceptors.request.use(config => {
//
//     return config;
// });

// 2. response(정상/에러) 핸들링
instance.interceptors.response.use(undefined, async (error) => {
    if (error.config && error.response) {
        switch (error.response.status) {
            case 400: {
                break;
            }
            case 401: { // accessToken 유효하지 않은경우
                if(store.state.refreshToken){
                    try {
                        await store.dispatch("refresh", { refreshToken: store.state.refreshToken, _cert: "" });
                        error.config.headers["Authorization"] = `Bearer ${store.state.accessToken}`;
                    } catch (error) {
                        await store.dispatch("logout");
                    }
                    return instance.request(error.config);
                }
                break;
            }
            case 403: {
                // 회원정보수정 비밀번호 확인 5회 실패 로그아웃
                if (error.response.data.message === "5회 이상의 비밀번호 실패 기록이 확인 되었습니다.\n정보보호를 위해 계정이 잠금 상태로 전환되었으며,\n잠금 해제를 위해서는 고객센터를 통해 문의 바랍니다.\n고객센터 1800-9510") {
                    alert(error.response.data.message);
                    await store.dispatch("logout");
                } else {
                    alert(error.response.data.message);
                }
                break;
            }
        }
    }

    throw error;
});

export default instance;